import { render } from "./SocialMedia.vue?vue&type=template&id=21be224a"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__